import { Icon, type IconName } from '../ui/Icon'

/**
 * WHAT AN EMPTY CHAT CAN DO — owner, 2026-09-30: 在這一個空白的聊天室裡面放上一些引導的
 * 文字與圖片, 讓使用者可以瞭解 … 可以互相傳遞訊息, 使用手機 APP 就會有 Notification, 並且
 * 可以將 Agent 添加進來這些 Chat 裡面.
 *
 * Shown in place of "No messages yet." in a friend chat and in Project Chat alike — both
 * open the same member list from the title at the top, which is where notifications are
 * switched on and agents attached, so the steps below are true for both. Three rows, an
 * icon and a short line each (his taste, 2026-09-30: simple, no paragraphs); it goes away
 * with the first message.
 */
const ROWS: Array<{ icon: IconName; title: string; line: string }> = [
  { icon: 'chat', title: 'Message each other', line: 'Text, photos and files arrive instantly, on every device.' },
  {
    icon: 'notifications',
    title: 'Get notified',
    line: 'In the iPhone app, tap the name at the top and turn on notifications.',
  },
  { icon: 'smart_toy', title: 'Bring in your agents', line: 'Tap the name at the top, then Attach agents.' },
]

export function EmptyChatGuide({ kind, name }: { kind: 'friend' | 'project'; name: string }) {
  return (
    <div className="ecg" data-testid="empty-chat-guide">
      <p className="ecg-title">{kind === 'friend' ? `Start your chat with ${name}` : `Welcome to ${name}`}</p>
      <ul className="ecg-list">
        {ROWS.map((r) => (
          <li key={r.icon} className="ecg-row">
            <span className={`ecg-icon ecg-${r.icon}`} aria-hidden="true">
              <Icon name={r.icon} size={20} />
            </span>
            <span className="ecg-text">
              <span className="ecg-row-title">{r.title}</span>
              <span className="ecg-row-line">{r.line}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
